/* LF — Bloques de CRO del carrito. SPEKGEN 2026-09-21.
 *
 * HISTORIA DE UN BUG, para que no vuelva:
 * La v1 usaba un MutationObserver sobre <cart-drawer> para re-montar los bloques
 * cuando Shopify repinta .js-contents. Pero el temporizador escribe textContent
 * cada segundo, eso ES una mutacion de childList, el observador la veia, volvia a
 * montar, el montaje re-escribia... bucle infinito de microtareas y la pestana se
 * congelaba ("Page Unresponsive"). Ademas el carrusel dejaba un setInterval huerfano
 * por vuelta.
 *
 * La v2 no observa nada. Cada elemento se marca con data-lf-listo al montarse y un
 * barrido cada 2 s monta SOLO lo que no tenga la marca. Cuando Shopify repinta
 * .js-contents, los nodos nuevos vienen sin marca y el barrido los toma. Es
 * imposible que se realimente, y cuesta tres querySelectorAll cada 2 s.
 */
(function () {
  'use strict';

  var LENTO = window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function guarda(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function lee(k)       { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  /* Cada elemento se monta UNA vez. Marcar con un atributo no dispara nada. */
  function nuevos(sel) {
    return document.querySelectorAll(sel + ':not([data-lf-listo])');
  }
  function marca(el) { el.setAttribute('data-lf-listo', '1'); }

  /* ---------- 1. temporizador de reserva ---------- */
  var CLAVE = 'lf_cv2_reserva';

  function vencimiento(minutos) {
    var g = parseInt(lee(CLAVE) || '0', 10);
    if (g && g > Date.now()) return g;
    var nuevo = Date.now() + minutos * 60000;
    guarda(CLAVE, String(nuevo));
    return nuevo;
  }

  function pintaTimer(el) {
    marca(el);
    var min = parseInt(el.dataset.minutos || '10', 10);
    var out = el.querySelector('[data-lf-cv2-reloj]');
    if (!out) return;
    var fin = vencimiento(min);

    function tick() {
      if (!document.body.contains(el)) { clearInterval(el._i); return; }
      var resta = fin - Date.now();
      if (resta <= 0) {
        // Se reinicia. NO se vacia el carrito: no estamos apartando stock de verdad.
        try { sessionStorage.removeItem(CLAVE); } catch (e) {}
        fin = vencimiento(min);
        resta = fin - Date.now();
      }
      var s = Math.floor(resta / 1000);
      var txt = String(Math.floor(s / 60)).padStart(2, '0') + ':' +
                String(s % 60).padStart(2, '0');
      if (out.textContent !== txt) out.textContent = txt;   // solo escribe si cambia
    }
    tick();
    clearInterval(el._i);
    el._i = setInterval(tick, 1000);
  }

  /* ---------- 2. carrusel de confianza ---------- */
  function pintaCarrusel(el) {
    marca(el);
    var track  = el.querySelector('[data-lf-cv2-track]');
    var slides = el.querySelectorAll('.lf-cv2-trust__slide');
    var dots   = el.querySelectorAll('[data-lf-cv2-dot]');
    if (!track || slides.length < 2) return;

    var i = parseInt(lee('lf_cv2_slide') || '0', 10) % slides.length;

    function ve(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-current', d === i ? 'true' : 'false');
      }
      guarda('lf_cv2_slide', String(i));
    }

    function auto() {
      clearInterval(el._i);                       // un solo intervalo por elemento
      if (LENTO) return;
      el._i = setInterval(function () {
        if (!document.body.contains(el)) { clearInterval(el._i); return; }
        ve(i + 1);
      }, 5000);
    }

    ve(i); auto();

    for (var d = 0; d < dots.length; d++) {
      (function (n) {
        dots[n].addEventListener('click', function () { ve(n); auto(); });
      })(d);
    }

    // Swipe: el drawer es estrecho y el pulgar es el cursor.
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { ve(i + (dx < 0 ? 1 : -1)); auto(); }
      x0 = null;
    }, { passive: true });
  }

  /* ---------- 3. cuenta regresiva del corte de envio ---------- */
  function pintaCorte(el) {
    marca(el);
    var hora = parseInt(el.dataset.corte || '14', 10);   // hora local de la tienda
    var out  = el.querySelector('[data-lf-cv2-corte]');
    if (!out) return;
    function tick() {
      if (!document.body.contains(el)) { clearInterval(el._i); return; }
      var ahora = new Date();
      var corte = new Date(ahora);
      corte.setHours(hora, 0, 0, 0);
      if (corte <= ahora) corte.setDate(corte.getDate() + 1);
      var s = Math.floor((corte - ahora) / 1000);
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
      var txt = h > 0 ? (h + ' h ' + m + ' min') : (m + ' min');
      if (out.textContent !== txt) out.textContent = txt;
    }
    tick();
    clearInterval(el._i);
    el._i = setInterval(tick, 30000);
  }

  /* ---------- barrido ---------- */
  function monta() {
    nuevos('[data-lf-cv2-timer]').forEach(pintaTimer);
    nuevos('[data-lf-cv2-trust]').forEach(pintaCarrusel);
    nuevos('[data-lf-cv2-eta]').forEach(pintaCorte);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', monta);
  } else { monta(); }

  // Shopify repinta .js-contents sin avisar. Un barrido periodico toma lo nuevo
  // sin posibilidad de realimentarse, que es lo que congelo la pestana en la v1.
  setInterval(monta, 2000);

  window.lfCartV2 = { monta: monta };
})();
